<template>
  <div class="weatherLine" id="weatherLine" ref="weatherLine">132</div>
</template>

<script>
export default {
  name: "weatherLine",
  mounted() {
    this.weatherLine();
  },
  methods: {
    weatherLine() {
      let myEchart = this.$echarts.init(document.getElementById("weatherLine"));
      let option = {
        grid: {
          left: "2%",
          right: "2%",
          top: "0%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLabel: {
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#397cbc",
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: "#195384",
              },
            },
            data: ["1", "2", "3", "4", "5"],
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
           
            axisLabel: {
              show: false,
              formatter: "{value}",
              textStyle: {
                color: "#2ad1d2",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#27b4c2",
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: "#11366e",
              },
            },
          },
        ],
        series: [
          {
            name: "已采纳",
            type: "line",
            stack: "总量",
            symbol: "circle",
            symbolSize: 6,
            itemStyle: {
              normal: {
                color: "#fff",
                lineStyle: {
                  color: "#877a67",
                  width: 1,
                },
              },
            },
            markPoint: {
              itemStyle: {
                normal: {
                  color: "red",
                },
              },
            },
            data: [7, 8, 9, 8],
          },
          {
            name: "已发布",
            type: "line",
            stack: "总量",
            symbol: "circle",
            symbolSize: 6,

            itemStyle: {
              normal: {
                color: "#fff",
                lineStyle: {
                  color: "#877a67",
                  width: 1,
                },
              },
            },
            data: [27, 25, 28, 27],
          },
        ],
      };

      myEchart.setOption(option);
      window.addEventListener("resize", () => {
        myEchart.resize();
      });
    },
  },
};
</script>


<style scoped>
.weatherLine {
  width: 100%;
  height: 100%;
}
</style>